if (!customElements.get('kiive-console-hero')) {
  customElements.define('kiive-console-hero', class extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      this.controller = new AbortController();
      const {signal} = this.controller;
      this.tabs = [...this.querySelectorAll('[data-console-tab]')];
      this.panels = [...this.querySelectorAll('[data-console-panel]')];
      this.tabs.forEach((tab,index) => {
        tab.addEventListener('click', () => this.select(index), {signal});
        tab.addEventListener('keydown', event => {
          let next = index;
          if (event.key === 'ArrowRight') next = (index + 1) % this.tabs.length;
          else if (event.key === 'ArrowLeft') next = (index + this.tabs.length - 1) % this.tabs.length;
          else if (event.key === 'Home') next = 0;
          else if (event.key === 'End') next = this.tabs.length - 1;
          else return;
          event.preventDefault(); this.select(next); this.tabs[next].focus();
        }, {signal});
      });
      document.addEventListener('shopify:block:select', event => {
        const index = this.panels.findIndex(panel => panel.dataset.consolePanel === event.detail.blockId);
        if (index >= 0) this.select(index);
      }, {signal});
      this.select(0);
    }
    select(index) {
      this.tabs.forEach((tab,i) => { tab.setAttribute('aria-selected', String(i === index)); tab.tabIndex = i === index ? 0 : -1; });
      this.panels.forEach((panel,i) => { panel.hidden = i !== index; });
    }
    disconnectedCallback() { this.controller?.abort(); this.controller = null; }
  });
}
